import React, { useState, useEffect } from "react";
import axios from "../customAxios.js";
import {
  Grid,
  TextField,
  Typography,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
  Button,
  Autocomplete,
  Box,
} from "@mui/material";
import { courierPlan, shippingMethodEnumChoices } from "../helpers/enums.js";
import { useAuth } from "../hooks/useAuth.jsx";
import { Snackbar, Alert, Dialog, DialogTitle, DialogContent, DialogActions } from "@mui/material";



function WarehouseCard({
  index,
  wh,
  warehouseErrors,
  onChange,
  onRemove,
  shippingZones,
}) {

  const handleFieldChange = (e) => onChange(index, e);

  const { user } = useAuth();
  const admin_plan =   user.admin_plan?.plan_type;

  return (
    <Grid
      container
      spacing={2}
      mt={2}
      style={{ border: "1px solid #ccc", padding: 16, borderRadius: 8 }}
    >
      <Grid item xs={12}>
        <Typography variant="subtitle1">Bodega {index + 1}</Typography>
      </Grid>

      <Grid item xs={6} sm={2}>
        <TextField
          fullWidth
          label="Nombre de bodega"
          name="name"
          value={wh.name}
          onChange={handleFieldChange}
          error={!!warehouseErrors?.[index]?.name}
          helperText={wh.name === "" && "Campo obligatorio"}
        />
      </Grid>

      <Grid item xs={6} sm={2}>
        <TextField
          fullWidth
          label="Nombre encargado"
          name="store_keeper"
          value={wh.store_keeper}
          onChange={handleFieldChange}
          error={!!warehouseErrors?.[index]?.store_keeper}
          helperText={wh.store_keeper === "" && "Campo obligatorio"}
        />
      </Grid>

      <Grid item xs={6} sm={2}>
        <TextField
          fullWidth
          label="Teléfono encargado"
          name="phone"
          value={wh.phone}
          onChange={handleFieldChange}
          error={!!warehouseErrors?.[index]?.phone}
          helperText={wh.phone === "" && "Campo obligatorio"}
        />
      </Grid>

      <Grid item xs={6} sm={2}>
        <TextField
          fullWidth
          label="Email encargado"
          name="email"
          value={wh.email}
          onChange={handleFieldChange}
          error={!!warehouseErrors?.[index]?.email}
          helperText={wh.email === "" && "Campo obligatorio"}
        />
      </Grid>

      <Grid item xs={6} sm={4}>
        <TextField
          label="Whatsapp dudas (ej: 911112345)"
          name="customer_phone"
          value={wh.customer_phone}
          onChange={handleFieldChange}
        />
      </Grid>

      <Grid item xs={6} sm={2}>
        <TextField
          fullWidth
          label="Región"
          name="region"
          value={wh.region}
          onChange={handleFieldChange}
          error={!!warehouseErrors?.[index]?.region}
          helperText={wh.region === "" && "Campo obligatorio"}
        />
      </Grid>

      <Grid item xs={6} sm={2}>
        <TextField
          fullWidth
          label="Comuna"
          name="comuna"
          value={wh.comuna}
          onChange={handleFieldChange}
          error={!!warehouseErrors?.[index]?.comuna}
          helperText={wh.comuna === "" && "Campo obligatorio"}
        />
      </Grid>

      <Grid item xs={6} sm={2}>
        <TextField
          fullWidth
          label="Calle"
          name="street"
          value={wh.street}
          onChange={handleFieldChange}
          error={!!warehouseErrors?.[index]?.street}
          helperText={wh.street === "" && "Campo obligatorio"}
        />
      </Grid>

      <Grid item xs={6} sm={2}>
        <TextField
          fullWidth
          label="Número"
          name="number"
          value={wh.number}
          onChange={handleFieldChange}
          error={!!warehouseErrors?.[index]?.number}
          helperText={wh.number === "" && "Campo obligatorio"}
        />
      </Grid>

      <Grid item xs={6} sm={2}>
        <TextField
          fullWidth
          minRows={2}
          label="Referencia (ej: local 6 piso -1)"
          name="warehouse_comments"
          value={wh.warehouse_comments}
          onChange={handleFieldChange}
        />
      </Grid>

      {["lat", "long"].map((field, idx) => (
        <Grid key={idx} item xs={12} sm={2}>
          <TextField
            fullWidth
            label={field.charAt(0).toUpperCase() + field.replace("_", " ").slice(1)}
            name={field}
            value={wh[field]}
            onChange={handleFieldChange}
          />
        </Grid>
      ))}

      <Grid container spacing={2}>
        <Grid item xs={12} sm={3}>
          <FormControl fullWidth>
            <InputLabel>Shipping Zone</InputLabel>
            <Select
              name="shipping_zone"
              value={wh.shipping_zone}
              onChange={handleFieldChange}
              label="Shipping Zone"
            >
              {
              user.admin_plan?.plan_type === "admin_checkout" ? (
                  // temporal: only assign shiping zone "self_checkout"
                  <MenuItem key={214} value={214}>
                    self-checkout
                  </MenuItem>
                ) : (
                  shippingZones.map((zone) => (
                    <MenuItem key={zone.id} value={zone.id}>
                      {zone.name}
                    </MenuItem>
                  ))
                )
              }
            </Select>
          </FormControl>
        </Grid>

        <Grid item xs={12} sm={3}>
          <FormControl fullWidth>
            <InputLabel>Shipping Method</InputLabel>
            <Select
              name="shipping_method"
              value={wh.shipping_method}
              onChange={handleFieldChange}
              label="Shipping Method"
            >
              {shippingMethodEnumChoices.map((method) => (
                <MenuItem key={method.value} value={method.value}>
                  {method.label}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Grid>
      </Grid>

      {index > 0 && (
        <Grid item xs={12}>
          <Button variant="outlined" color="error" onClick={() => onRemove(index)}>
            Eliminar Warehouse
          </Button>
        </Grid>
      )}
    </Grid>
  );
}

export default function CreateSeller() {
  const get_couriers = "admins/couriers/";
  const get_admin_id = "admins/get_admin_id/";
  const get_admin_shipping_zones = "shipping_zones/get_admin_shipping_zones/";
  const create_seller = "admins/sellers/create/";
  const check_username = "admins/get_user_by_username/";


  const { user } = useAuth();

  const is_staff = user.is_staff;

  // Admins + selection duplicates (kept as requested)
  const [admins, setAdmins] = useState([]);
  const [adminPrefix, setAdminPrefix] = useState("");
  const [selectedAdminID, setSelectedAdminId] = useState(0);
  const [selectedAdminName, setSelectedAdminName] = useState("");

  // Shipping zones for selected admin
  const [shippingZones, setShippingZones] = useState([]);

  // Validation + email checks
  const [formErrors, setFormErrors] = useState({});
  const [isValidEmail, setIsValidEmail] = useState(true);
  const [emailExists, setEmailExists] = useState(false);

  // Submit flow states
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitSuccess, setSubmitSuccess] = useState(false);
  const [submitError, setSubmitError] = useState(null);

  // Snackbar control
  const [openSnackbar, setOpenSnackbar] = useState(false);

  // Modal control
  const [openSuccessModal, setOpenSuccessModal] = useState(false);

  // form data
  const [formData, setFormData] = useState({
    admin: "",
    user: "",
    razon_social: "",
    rut: "",
    plan: "",
    region: "",
    comuna: "",
    street: "",
    number: "",
    lat: "",
    long: "",
    warehouses: [
      {
        name: "",
        store_keeper: "",
        phone: "",
        email: "",
        capacity: 10000, // temporally
        region: "",
        comuna: "",
        street: "",
        number: "",
        lat: "",
        long: "",
        customer_phone: "",
        shipping_zone: "",
        shipping_method: "",
        warehouse_comments: "",
      },
    ],
  });

  const handleCloseSnackbar = () => setOpenSnackbar(false);
  const handleCloseSuccessModal = () => setOpenSuccessModal(false);
  // ---------- Effects ----------
  useEffect(() => {
    if (is_staff) {
      fetchCouriers();
    } else {
      getAdminId();
    }
  }, [is_staff]);

  useEffect(() => {
    console.log("email existe: ", emailExists);
  }, [emailExists]);

  useEffect(() => {
    console.log("email es valido: ", isValidEmail);
  }, [isValidEmail]);

  useEffect(() => {
    if (selectedAdminID) {
      console.log("Getting shipping zones for admin:", selectedAdminID);
      getShippingZones(selectedAdminID);
      console.log("getShippingZones", shippingZones);
      setFormData((prev) => ({ ...prev, admin: selectedAdminID }));
    }
  }, [selectedAdminID]);

  // ---------- API helpers ----------
  async function fetchCouriers() {
    try {
      const {
        data: { serialized_admins },
      } = await axios.get(get_couriers);
      setAdmins(serialized_admins);
    } catch (error) {
      console.error(`Error al obtener los couriers: ${error}`);
    }
  }

  async function getAdminId() {
    try {
      const {
        data: { admin_user },
      } = await axios.get(get_admin_id);
      setSelectedAdminId(admin_user[0].id);
      setSelectedAdminName(admin_user[0].user.first_name + " " + admin_user[0].user.last_name);
      setAdminPrefix(admin_user[0].company_prefix);
      setFormData((prev) => ({ ...prev, admin: admin_user[0].id }));
    } catch (error) {
      console.log(`Error al cargar los datos de admin: ${error}`);
    }
  }

  async function getShippingZones(adminId) {
    try {
      const {
        data: { serialized_shippingzones },
      } = await axios.get(`${get_admin_shipping_zones}${adminId}/`);
      setShippingZones(serialized_shippingzones);
    } catch (error) {
      console.error(`Error al cargar las shipping zones: ${error}`);
    }
  }

  async function validateEmailFormat(userEmail) {
    const email = userEmail.trim();
    const correctEmailFormat = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);

    if (!correctEmailFormat) {
      console.warn("Formato de correo inválido");
      setIsValidEmail(false);
      return;
    }
    setIsValidEmail(true);
    checkUserEmail(email);
  }

  async function checkUserEmail(userEmail) {
    try {
      const response = await axios.get(`${check_username}${userEmail}/`);
      const email_verification = response.data.email_verification;
      console.log("Response:", response.data.email_verification);
      if (!email_verification) {
        setEmailExists(true);
      } else {
        setEmailExists(false);
      }
    } catch (error) {
      console.error("Error al verificar el usuario:", error);
    }
  }

  // ---------- Handlers ----------
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handlePlanChange = (_, newValue) => {
    setFormData((prev) => ({ ...prev, plan: newValue ? newValue.value : "" }));
    console.log("plan es: ", newValue);
  };

  const handleAdminSelect = (e) => {
    if (e.target.value) {
      const { id, prefix } = JSON.parse(e.target.value);
      setFormData((prev) => ({ ...prev, admin: id }));
      getShippingZones(id);
      setAdminPrefix(prefix);
      setSelectedAdminId(id);

      const found = admins.find((a) => a.id === id);
      if (found) {
        setSelectedAdminName(found.user.first_name + " " + found.user.last_name);
      }
      console.log("Admin seleccionado:", id, prefix);
    }
  };

  const handleWarehouseChange = (index, e) => {
    const { name, value } = e.target;
    setFormData((prev) => {
      const newWarehouses = [...prev.warehouses];
      newWarehouses[index] = { ...newWarehouses[index], [name]: value };
      return { ...prev, warehouses: newWarehouses };
    });
  };

  const addWarehouse = () => {
    if (formData.warehouses.length < 10) {
      setFormData((prev) => ({
        ...prev,
        warehouses: [
          ...prev.warehouses,
          {
            name: "",
            store_keeper: "",
            phone: "",
            email: "",
            capacity: "",
            region: "",
            comuna: "",
            street: "",
            number: "",
            lat: "",
            long: "",
            customer_phone: "",
            shipping_zone: "",
            shipping_method: "",
            warehouse_comments: "",
          },
        ],
      }));
    }
  };

  const removeWarehouse = (index) => {
    const updated = [...formData.warehouses];
    updated.splice(index, 1);
    setFormData((prev) => ({ ...prev, warehouses: updated }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSubmitError(null);
    setSubmitSuccess(false);
    setIsSubmitting(true);

    console.log("form attempts:", formData);

    const errors = {};

    const requiredFields = [
      "admin",
      "user",
      "razon_social",
      "rut",
      "plan",
      "region",
      "comuna",
      "street",
      "number",
    ];

    requiredFields.forEach((field) => {
      if (!formData[field] || formData[field].toString().trim() === "") {
        errors[field] = "Este campo es obligatorio";
      }
    });

    // ✅ Validate warehouses
    const requiredWarehouseFields = [
      "name",
      "store_keeper",
      "phone",
      "email",
      "region",
      "comuna",
      "street",
      "number",
      "shipping_zone",
      "shipping_method",
    ];

    const warehouseErrors = [];

    formData.warehouses.forEach((warehouse, index) => {
      const currentErrors = {};
      requiredWarehouseFields.forEach((field) => {
        if (!warehouse[field] || warehouse[field].toString().trim() === "") {
          currentErrors[field] = "Este campo es obligatorio";
        }
      });

      if (Object.keys(currentErrors).length > 0) {
        warehouseErrors[index] = currentErrors;
      }
    });

    if (warehouseErrors.length > 0) {
      errors.warehouses = warehouseErrors;
    }

    setFormErrors(errors);

    if (Object.keys(errors).length > 0) {
      console.log("Validation errors:", errors);
      setIsSubmitting(false);

      setSubmitError("Por favor complete todos los campos obligatorios.");
      setOpenSnackbar(true);

      return;
    }

    if (!isValidEmail) {
      setSubmitError("Formato de correo inválido.");
      setOpenSnackbar(true);
      setIsSubmitting(false);
      return;
    }

    if (emailExists) {
      setSubmitError("El usuario ya existe en el sistema. Debe usar otro correo.");
      setOpenSnackbar(true);
      setIsSubmitting(false);
      return;
    }

    const payload = { ...formData };

    try {
      console.log("Sending POST to:", create_seller);

      const response = await axios.post(create_seller, payload);

      console.log("Seller created successfully:", response.data);

      setSubmitSuccess(true);
      setOpenSuccessModal(true);

      setFormData({
        admin: "",
        user: "",
        razon_social: "",
        rut: "",
        plan: "",
        region: "",
        comuna: "",
        street: "",
        number: "",
        lat: "",
        long: "",
        warehouses: [
          {
            name: "",
            store_keeper: "",
            phone: "",
            email: "",
            capacity: 10000,
            region: "",
            comuna: "",
            street: "",
            number: "",
            lat: "",
            long: "",
            customer_phone: "",
            shipping_zone: "",
            shipping_method: "",
            warehouse_comments: "",
          },
        ],
      });

      // setTimeout(() => {
      //   window.location.href = "/home/my-sellers";
      // }, 1500);

    } catch (error) {
      console.error("Error creating seller:", error);

      if (error.response) {
        console.error("Backend error:", error.response.data);

        setSubmitError(
          error.response.data.error ||
          error.response.data.message ||
          "Error desde el servidor."
        );
      } else if (error.request) {
        console.error("No response from server:", error.request);
        setSubmitError("No hay respuesta del servidor.");
      } else {
        console.error("Axios error:", error.message);
        setSubmitError("Error inesperado.");
      }

      setOpenSnackbar(true);

    } finally {
      setIsSubmitting(false);
    }
  };


  return (
    <form onSubmit={handleSubmit}>
      <Grid container spacing={2}>
        <Grid item xs={12} className="mg-t-20">
          <Typography variant="h4">Crear Seller</Typography>
        </Grid>

        <Grid item xs={12} className="mg-t-20">
          <Grid container spacing={2} mt={1}>
            {is_staff ? (
              <Grid item xs={12} sm={6}>
                <Typography variant="h4">Seleccionar Operador Logístico</Typography>

                <FormControl fullWidth>
                  <InputLabel>Operador Logístico</InputLabel>
                  <Select
                    value={
                      formData.admin
                        ? JSON.stringify({
                          id: formData.admin,
                          prefix: admins.find((a) => a.id === formData.admin)?.company_prefix || "",
                        })
                        : ""
                    }
                    name="admin"
                    label="Operador Logístico"
                    onChange={handleAdminSelect}
                  >
                    {admins.map((admin) => (
                      <MenuItem
                        key={admin.id}
                        value={JSON.stringify({ id: admin.id, prefix: admin.company_prefix })}
                      >
                        {admin.user.email} - {admin.company_prefix}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>
            ) : (
              <Grid item xs={12} sm={6}>
                <Typography>Admin: {selectedAdminName}</Typography>
              </Grid>
            )}
          </Grid>
        </Grid>

        {/* Company data */}
        <Grid item xs={12} mt={2}>
          <Typography variant="h6">Datos Compañía:</Typography>
          <Grid container spacing={3} mt={1}>
            <Grid item xs={12} sm={2}>
              <TextField
                fullWidth
                label="Razón Social"
                name="razon_social"
                value={formData.razon_social}
                onChange={handleChange}
                error={!!formErrors.razon_social}
                helperText={formData.razon_social === "" && "Campo obligatorio"}
              />
            </Grid>

            <Grid item xs={12} sm={2}>
              <TextField
                fullWidth
                label="RUT"
                name="rut"
                value={formData.rut}
                onChange={handleChange}
                error={!!formErrors.rut}
                helperText={formData.rut === "" && "Campo obligatorio"}
              />
            </Grid>

            <Grid item xs={12} sm={3}>
              <Box display="flex" alignItems="center">
                <TextField
                  fullWidth
                  type="email"
                  label="User Email"
                  name="user"
                  value={formData.user}
                  onChange={handleChange}
                  onBlur={(e) => validateEmailFormat(e.target.value)}
                  error={!!formErrors.user || !isValidEmail || emailExists}
                />

                {!isValidEmail && (
                  <Typography variant="caption" color="error" sx={{ mt: 0.5 }}>
                    Dirección inválida
                  </Typography>
                )}
                {isValidEmail && emailExists && (
                  <Typography variant="caption" color="error" sx={{ mt: 0.5 }}>
                   El usuario ya existe en el sistema
                  </Typography>
                )}
              </Box>
            </Grid>

            <Grid item xs={12}>
              <Grid item xs={12} sm={4}>
                <FormControl fullWidth>
                  <Autocomplete
                    fullWidth
                    id="plan-select"
                    options={courierPlan}
                    getOptionLabel={(p) => (p ? p.label : "")}
                    isOptionEqualToValue={(option, value) => option.value === value?.value}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label="Tipo de Plan"
                        error={!!formErrors.plan}
                        helperText={formData.plan === "" && "Campo obligatorio"}
                      />
                    )}
                    value={courierPlan.find((c) => c.value === formData.plan) || null}
                    onChange={handlePlanChange}
                  />
                </FormControl>
              </Grid>
            </Grid>
          </Grid>
        </Grid>

        {/* Commercial address */}
        <Grid item xs={12} mt={4}>
          <Typography variant="h6">Dirección Comercial:</Typography>
          <Grid container spacing={2} mt={1}>
            {["region", "comuna", "street", "number"].map((field, idx) => (
              <Grid key={idx} item xs={12} sm={2}>
                <TextField
                  fullWidth
                  label={field.charAt(0).toUpperCase() + field.slice(1)}
                  name={field}
                  value={formData[field]}
                   error={!!formErrors[field]}
                  onChange={handleChange}
                  helperText={formData[field] === "" && "Campo obligatorio"}
                />
              </Grid>
            ))}
          </Grid>
        </Grid>

        {/* Warehouses */}
        <Grid item xs={12} mt={4}>
          <Typography variant="h6">Bodegas: Máximo 10</Typography>

          {formData.warehouses.map((wh, index) => (
            <WarehouseCard
              key={index}
              index={index}
              wh={wh}
              warehouseErrors={formErrors?.warehouses}
              onChange={handleWarehouseChange}
              onRemove={removeWarehouse}
              shippingZones={shippingZones}
            />
          ))}

          {formData.warehouses.length < 10 && (
            <Grid item xs={12} mt={2}>
              <Button variant="outlined" onClick={addWarehouse}>
                Agregar Warehouse
              </Button>
            </Grid>
          )}
        </Grid>

        <Grid item xs={12} mt={4}>
          <Button type="submit" variant="contained" color="primary">
            Guardar Seller
          </Button>
        </Grid>
      </Grid>
      <Snackbar
        open={openSnackbar}
        autoHideDuration={4000}
        onClose={handleCloseSnackbar}
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
      >
        <Alert onClose={handleCloseSnackbar} severity="error" sx={{ width: "100%" }}>
          {submitError}
        </Alert>
      </Snackbar>
      <Dialog open={openSuccessModal} onClose={handleCloseSuccessModal}>
        <DialogTitle>Seller creado correctamente</DialogTitle>
        <DialogContent>
          El nuevo seller fue creado exitosamente. Se ha enviado un correo con sus credenciales.
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseSuccessModal}>Cerrar</Button>
        </DialogActions>
      </Dialog>
    </form>
  );
}
